import React, { FC, useState } from "react";
import Logo from "shared/Logo/Logo";
import MenuBar from "shared/MenuBar/MenuBar";
// import AvatarDropdown from "./AvatarDropdown";
import Navigation from "shared/Navigation/Navigation";
// import CartDropdown from "./CartDropdown";
import { Link, useNavigate } from "react-router-dom";
import { PhoneIcon } from "@heroicons/react/24/outline";

export interface MainNav2LoggedProps {}

const MainNav2Logged: FC<MainNav2LoggedProps> = () => {
  const inputRef = React.createRef<HTMLInputElement>();
  const [showSearchForm, setShowSearchForm] = useState(false);
  const navigate = useNavigate();

  const renderMagnifyingGlassIcon = () => {
    return (
      <svg
        width={22}
        height={22}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 22L20 20"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

  const renderContent = () => {
    return (
      <div className="h-20 flex justify-between">
        <div className="flex items-center lg:hidden lg:flex-1">
          <MenuBar />
        </div>

        <div className=" flex items-center">
          <Logo className="flex-shrink-0 " />
          <Link to="/">
            <p className="mx-2 lg:mx-4 lg:text-3xl font-bold text-sm">
              {" "}
              <span className="text-primary-500">Devi </span>{" "}
              <span className="text-black"> Plastic </span>{" "}
            </p>
          </Link>
        </div>
        <div className="hidden lg:flex">
          <Navigation />
        </div>
        <div className="flex items-center">
          <a
            href="tel:9924823363"
            className="
      relative inline-flex items-center gap-1
      px-4 py-2 text-xs
      sm:gap-2 sm:px-6 sm:py-3 sm:text-sm
      text-white font-semibold rounded-md
      bg-primary-500 hover:bg-primary-600
      transition-all duration-300
    "
          >
            <span className="relative flex items-center gap-1 sm:gap-2">
              <PhoneIcon className="h-4 w-4 sm:h-5 sm:w-5" />
              Call Now
            </span>
          </a>
        </div>
      </div>
    );
  };

  return (
    <div className="nc-MainNav2Logged relative z-10 bg-white dark:bg-neutral-900 border-b border-slate-100 dark:border-slate-700">
      <div className="container ">{renderContent()}</div>
    </div>
  );
};

export default MainNav2Logged;
